import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public constructor(
    private _matIconRegistry: MatIconRegistry,
    private _domSanitizer: DomSanitizer,
    private translateService: TranslateService
  ) {
    //_matIconRegistry.setDefaultFontSetClass('material-icons-outlined');
    const defaultFontSetClasses = _matIconRegistry.getDefaultFontSetClass();
    const outlinedFontSetClasses = defaultFontSetClasses
      .filter((fontSetClass) => fontSetClass !== 'material-icons')
      .concat(['material-symbols-outlined']);
    _matIconRegistry.setDefaultFontSetClass(...outlinedFontSetClasses);
    this.registerSvgIcon();
  }



  private registerSvgIcon() {
    const icons = ['bin', 'edit', 'user', 'info', 'pdf', 'three-dots', 'done', 'save'];

    icons.forEach((icon) => {
      this._matIconRegistry.addSvgIcon(
        `total-${icon}`,
        this._domSanitizer.bypassSecurityTrustResourceUrl(
          `../../../../assets/icons/${icon}.svg`
        )
      );
    });
  }
}
